<template>
  <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
    <div
      v-for="(image, index) in adventureImages"
      :key="index"
      class="card-glass trip-card flex flex-col overflow-hidden h-full p-0"
      v-motion
      :initial="{ opacity: 0, y: 40 }"
      :visibleOnce="{ opacity: 1, y: 0 }"
      :delay="200 * index"
      :duration="800"
    >
      <router-link
        :to="image.link"
        class="flex flex-col text-stone-800 hover:text-emerald transition-colors duration-300"
      >
        <img
          v-lazy="image.src"
          :alt="image.alt"
          class="w-full h-56 object-cover"
        />
        <div class="p-4 flex-1 flex flex-col justify-between">
          <h3
            class="text-xl font-bold uppercase italic text-center text-text-base"
          >
            {{ image.text }}
          </h3>
          <p class="text-sm text-text-muted text-center mt-2">
            {{ image.description }}
          </p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const adventureImages = ref([
  {
    src: require("@/assets/collage/c1.jpg"),
    link: "/join-adventure",
    text: "Adventure Trips",
    description:
      "Embark on whitewater rafting, volcano hikes, and canyoning with waterfall rappels—designed for adrenaline seekers craving unforgettable, heart-pounding thrills.",
    delay: 600,
  },
  {
    src: require("@/assets/collage/c3.jpg"),
    link: "/family-trips",
    text: "Family Trips",
    description:
      "Create lasting family memories with guided nature walks, wildlife safaris, beachside games, and picnics—safe, fun, and unforgettable adventures for all ages.",
    delay: 700,
  },
  {
    src: require("@/assets/collage/customTrips.jpg"),
    link: "/custom-trips",
    text: "Custom Trips",
    description:
      "Tailor every detail of your trip—from jungle treks and highland hikes to cultural tours and beach retreats—planned to fit your group’s pace, interests, and budget.",
    delay: 800,
  },
  {
    src: require("@/assets/collage/c11.jpg"),
    link: "/adventure-plus",
    text: "Adventure Plus",
    description:
      "From high-octane challenges to purpose-driven retreats, Adventure Plus unites student groups, charities, and corporate teams through unforgettable experiences.",
    delay: 900,
  },
]);
</script>

<style scoped>
/* Optional visual enhancements */
</style>
